// extracted by css-extract-rspack-plugin
export default {"Box":"archive-header-wrapper-module__Box__ThVYr","Box_1":"archive-header-wrapper-module__Box_1__o0fZ6"};